/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConsultationStatus {
    SCHEDULED = 'scheduled',
    PRESENT = 'present',
    ABSENT = 'absent',
}
